export default __webpack_public_path__ + "static/media/logoVector.097ad814.svg";